import axios from '../config/axios';

const API_URL = `${(
  process.env.REACT_APP_API_URL ||
  'https://api-backend-clinical-intake-uat.dizzaroo.com'
).replace(/\/$/, '')}/api/soa-edit`;

/**
 * One stateless edit turn against an already-populated tiered SOA table (see
 * EditSoaDialog). Unlike the S9 chat service, there is no workspace to fetch
 * or publish — the caller holds `table` + `messages` locally and sends both
 * each turn, then persists the result itself via documentEditor.service.js.
 */
const soaEditService = {
  sendSoaEditMessage: async ({ table, messages }) => {
    try {
      const response = await axios.post(`${API_URL}/chat`, { table, messages });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default soaEditService;
